// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1zPyO","cardsWrap":"styles-module--cardsWrap--3_oe7","card":"styles-module--card--2VHe_","title":"styles-module--title--38L8t"};